import { computeAvgMonthlyContribution, forecastGoalCompletion } from '@/features/savings/utils/forecastSavings';

function avg3moForCategory(allTxns, category, selMonth, selYear, incomeList) {
  const priorKeys = [];
  for (let i = 1; i <= 3; i++) {
    let m = selMonth - i;
    let y = selYear;
    if (m < 0) { m += 12; y--; }
    priorKeys.push(y + '-' + String(m + 1).padStart(2, '0'));
  }

  const byMonth = {};
  for (const t of (allTxns || [])) {
    if (!t || !t.date || t.category !== category) continue;
    if (incomeList && incomeList.includes(t.category)) continue;
    const key = t.date.slice(0, 7);
    if (!priorKeys.includes(key)) continue;
    byMonth[key] = (byMonth[key] || 0) + (Number(t.amount) || 0);
  }

  const months = priorKeys.filter(k => (byMonth[k] || 0) > 0);
  if (months.length < 2) return null;
  const total = months.reduce((s, k) => s + byMonth[k], 0);
  return total / months.length;
}

export function computeWhatIf(allTxns, category, reductionPct, selMonth, selYear, incomeList, goals) {
  if (incomeList && incomeList.includes(category)) return null;

  const avg3mo = avg3moForCategory(allTxns, category, selMonth, selYear, incomeList);
  if (avg3mo === null || avg3mo < 10) return null;

  const monthlySavings = avg3mo * (reductionPct / 100);
  const today = new Date();

  const goalImpacts = (goals || [])
    .filter(g => (Number(g.remaining) || 0) > 0)
    .map(g => {
      const currentAvg = computeAvgMonthlyContribution(allTxns, g.id, today);
      const { estimatedMonths: currentMonths } = forecastGoalCompletion(g, currentAvg);
      const newAvg = currentAvg + monthlySavings;
      const { estimatedMonths: newMonths } = forecastGoalCompletion(g, newAvg);
      const monthsSaved = Math.max(0, (currentMonths || 0) - (newMonths || 0));
      return { goalId: g.id, name: g.name, currentMonths: currentMonths || 0, newMonths: newMonths || 0, monthsSaved };
    });

  return { avg3mo, monthlySavings, goalImpacts };
}
